import { WorkstreamState } from '@/pages/OperationsAdministration/types/WorkstreamState';
import {
    getColumnsForState,
    WorkstreamDefinitionOperationConfigGridRow
} from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';
import {
    computed, MaybeRefOrGetter, ref, toValue, watch
} from 'vue';
import { ColTypeDef } from '@ag-grid-community/core';
import StatusSelectionCellRenderer from '@/pages/OperationsAdministration/components/StatusSelectionCellRenderer.vue';
import DateTimeCellRenderer from '@/pages/OperationsAdministration/components/DateTimeCellRenderer.vue';

export function useWorkstreamConfigGridData(params: {
    data: MaybeRefOrGetter<WorkstreamDefinitionOperationConfigGridRow[]>;
    state: MaybeRefOrGetter<WorkstreamState>;
}) {
    const columns = computed(() => getColumnsForState(toValue(params.state)));
    const resetData = () => toValue(params.data).filter((r) => r.state === toValue(params.state));

    const rows = ref(resetData());
    watch(() => params.data, () => {
        rows.value = resetData();
    });

    const columnTypes = {
        name: {
            cellRenderer: (p: {value: unknown}) => `<b>${p.value}</b>`,
            filter: true,
            suppressSizeToFit: true,
            minWidth: 100
        },
        timezone: { suppressSizeToFit: true, minWidth: 100 },
        formattedDate: {
            cellRenderer: DateTimeCellRenderer,
            cellRendererParams: { format: 'date' },
            suppressSizeToFit: true,
            minWidth: 100
        },
        formattedDateTime: {
            cellRenderer: DateTimeCellRenderer,
            cellRendererParams: { format: 'datetime' },
            suppressSizeToFit: true,
            minWidth: 100
        },
        sources: {
            valueGetter: (p) => p.data?.sources.join(', '),
            filter: true,
            minWidth: 200
        },
        status: {
            cellRenderer: StatusSelectionCellRenderer,
            cellClass: 'status-cell',
            resizable: false,
            width: 134,
            suppressAutoSize: true,
            suppressSizeToFit: true,
            pinned: 'right'
        }
    } as Record<string, ColTypeDef>;

    return {
        rows,
        columns,
        columnTypes,
        resetData
    };
}